import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/card';
import {
  Target,
  Globe,
  Shield,
  Users,
  Zap
} from 'lucide-react';

const About = () => {
  const companyValues = [
    {
      title: 'Innovation',
      description: 'Pushing the boundaries of AI validation and security',
      icon: Zap
    },
    {
      title: 'Transparency',
      description: 'Open and honest about AI capabilities and limitations',
      icon: Globe
    },
    {
      title: 'Security',
      description: 'Prioritizing ethical and safe AI development',
      icon: Shield
    },
    {
      title: 'Collaboration',
      description: 'Building a community of responsible AI practitioners',
      icon: Users
    }
  ];

  return (
    <div className="min-h-screen bg-background py-16">
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <section className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About <span className="text-primary">LLM Checks</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Empowering developers and researchers to build responsible, reliable, and safe AI systems
          </p>
        </section>

        {/* Mission Section */}
        <section className="max-w-4xl mx-auto mb-16">
          <Card className="border-0 shadow-xl">
            <CardHeader>
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="w-8 h-8 text-primary" />
              </div>
              <CardTitle className="text-center">Our Mission</CardTitle>
              <CardDescription className="text-center">
                To revolutionize AI validation and ensure the highest standards of quality and safety
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-center text-muted-foreground">
                We believe that as AI becomes more powerful, it's crucial to have robust,
                comprehensive validation tools that go beyond traditional testing methods.
                Our platform is designed to help developers and organizations build AI systems
                that are not just powerful, but also ethical, secure, and trustworthy.
              </p>
            </CardContent>
          </Card>
        </section>

        {/* Company Values */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Our Core Values</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              The principles that guide our approach to AI validation and development
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {companyValues.map((value, index) => (
              <Card key={index} className="text-center border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="pt-6">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <value.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="font-semibold mb-2">{value.title}</h3>
                  <p className="text-sm text-muted-foreground">{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
